<template>
  <div class="main-container groupitem-table-height">
    <transition :css="false">
    <el-dialog title="Edit GroupItems" :visible.sync="editModal" width="40%">
      <form>
        <arnergy-dynamic
            v-model="form.groupID"
            label="Select Group"
            :items="groups"
            @subgroup="getSubgroupss"
          />

           <div v-show="form.groupID" class="form-check ml-3">
            <input
              class="form-check-input"
              type="checkbox"
              value=""
              v-model="form.status"
              id="defaultCheck1"
            />
            <label class="form-check-label" for="defaultCheck1">
              Do you want to add device to Subgroup?
            </label>
          </div>
          <br />
          <div v-show="form.status">
            <arnergy-select
              v-model="form.subgroup"
              label="Subgroup"
              :items="subgroups"
            />
          </div>

        <div class="form-group">
          <label for="exampleFormControlTextarea1">Device ID</label>
          <multiselect
              v-model="form.device"
              :options="devices"
              :multiple="false"
              :close-on-select="false"
              :clear-on-select="false"
              :preserve-search="true"
              placeholder="Select Devices You want"
              label="id"
              track-by="id"
              :preselect-first="false"
            >
              <template slot="selection" slot-scope="{ values, search, isOpen }"
                ><span
                  class="multiselect__single"
                  v-if="values.length &amp;&amp; !isOpen"
                  >{{ values.length }} options selected</span
                ></template
              >
            </multiselect>
        </div>
    
        <div class="pt-4 text-right">
          <div v-if="loader" className="text-center">
            <div class="submit-gif">
              <div
                class="spinner-border"
                style="width: 3rem; height: 3rem;"
                role="status"
              >
                <span class="sr-only">Loading...</span>
              </div>
            </div>
          </div>
          <div v-else>
            <button class="btn btn-primary" @click="updateGroup">
              Edit GroupItems
            </button>
          </div>
        </div>
      </form>
    </el-dialog>
    </transition>
    <div style="width: 100%;">
      
      <el-input
        style="max-width: 200px;"
        placeholder="Type something"
        prefix-icon="el-icon-search"
        a
        v-model="searchTerm"
      ></el-input>
      <vue-good-table
        :columns="fields"
        :rows="getGroupItems"
        :search-options="{ enabled: true, externalQuery: searchTerm }"
        :pagination-options="{ enabled: true }"
      >
        <template slot="table-row" slot-scope="props" style="background: red;">
          <span v-if="props.column.field == 'actions' && usertype != 'customer admin'">
            <b-button
            :disabled="loading"
              size="md"
              variant="success"
              @click="editmodal(props.row.id)"
            >
              {{loading?"Loading...":"Edit GroupItems"}} &nbsp;
              <span class="fa fa-wrench"></span>
            </b-button>
          </span>
          <span v-else>{{ props.row[props.column.field] }}</span>
        </template>

        <template slot="pagination-bottom" slot-scope="props">
          <grey-pagination
            :total="props.total"
            :pageChanged="props.pageChanged"
            :perPageChanged="props.perPageChanged"
          ></grey-pagination>
        </template>
      </vue-good-table>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from 'vuex'
import {
  Select,
  Button,
  Autocomplete,
  Form,
  FormItem,
  Radio,
  Dialog,
  RadioGroup,
  RadioButton,
  // ...
} from 'element-ui'
import moment from 'moment'
import Multiselect from "vue-multiselect";
import ArnergySelect from "../kitchen/ArnergySelect.vue";
import ArnergyDynamic from "../kitchen/AnergySelectDynamic.vue";
import "vue-multiselect/dist/vue-multiselect.min.css";
moment.updateLocale('en', {
  monthsShort: 'jan_feb_mar_apr_may_june_july_aug_sept_oct_nov_dec'.split('_'),
})

const items = []
export default {
  components: {
    'el-dialog': Dialog,
    Multiselect,
    ArnergyDynamic,
    ArnergySelect,
  },
  data() {
    return {
      searchTerm: '',
      selectOption: {
        enabled: true,
      },
    editModal: false,
      loader: false,
      form: {
        groupID: '',
        subgroup: '',
        device: '',
        status:false,
      },
      updateID: '',
          groups: [{ id: null, name: null }],
      subgroups: [{ id: null, name: null }],
      value: [],
      items: items,
      fields: [
        {
          field: 'groupname',
          label: 'Group Name',
          sortable: 'true',
        },
        {
          field: 'subgroupname',
          label: 'Subgroup Name',
          sortable: 'true',
        },
        {
          field: 'deviceid',
          label: 'Device ID',
          sortable: 'true',
        },
        {
          field: 'actions',
          label: 'Actions',
        },

        // { key: 'dob', label: 'Date of birth', sortable: 'true'},
      ],
      cxTeamFields: [
        {
          field: 'id',
          label: 'Group Name',
          sortable: 'true',
        },
        {
          field: 'fu',
          label: 'Subgroup Name',
          sortable: 'true',
        },
        {
          field: 'Device',
          label: 'User Type',
          sortable: 'true',
        },
        {
          field: 'Status',
          label: 'E-mail',
          sortable: 'true',
        },
        // { key: 'dob', label: 'Date of birth', sortable: 'true'},
        {
          field: 'gender',
          label: 'Gender',
          sortable: 'true',
        },
        // { key: 'wallet_balance', label: 'Wallet Balance', sortable: 'true'},
        // { key: 'is_active', label: 'Status', sortable: 'true'},
        // { key: 'last_login', label: 'Last Login', sortable: 'true'},
        {
          field: 'phoneNumber',
          label: 'Phone Number',
          sortable: 'true',
        },
        // { key: 'address', label: 'Address', sortable: 'true'},
        {
          field: 'updatedAt',
          label: 'Last Seen',
          sortable: 'true',
        },
        {
          field: 'actions',
          label: 'Actions',
        },
      ],
      currentPage: 1,
      details: ['UserDetails', 'allowUser'],
      perPage: 10,
      totalRows: items.length,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      filter: null,
      loading:false,
      modalInfo: {
        title: '',
        content: '',
      },
      devices:[]
    }
  },
  computed: {
    ...mapGetters([
      'getUserById',
      'getDeviceById',
      'getUsers',
      'getGroups',
      'getSubgroups',
      'getGroupItems',
      'getDummy',
      'getDevices',
    ]),
    isACxTeam: {
      get() {
        if (this.$can('am', 'cxTeam') || this.$can('edit', 'user')) {
          return true
        } else {
          return true
        }
      },
    },
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return {
            text: f.label,
            value: f.key,
          }
        })
    },
  },
  methods: {
    formatDate(date) {
      return moment(date).format('Do MMM YYYY')
    },
    navTo(url, user) {
      this.$router.push({
        name: url,
        params: {
          userId: user,
        },
      })
    },
    info(item, index, button) {
      this.modalInfo.title = `Row index: ${index}`
      this.modalInfo.content = JSON.stringify(item, null, 2)
      this.$root.$emit('bv::show::modal', 'modalInfo', button)
    },
    resetModal() {
      this.modalInfo.title = ''
      this.modalInfo.content = ''
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    fetchGroupItems() {
      const HTTP = this.$httpUtils.instance
      //  filter={"include": ["installations"]}
      const url = `/groupItems/getGroupItems`
      HTTP.post(url)
        .then((response) => {
          const list = response.data
          this.$store.commit('saveGroupItems', list)
          // console.log(this.getUserById(1))
        })
        .catch((error) => {
          console.log('error', error)
        })
    },
    editmodal(id) {
      this.loading=true;
      this.updateID = id
      const HTTP = this.$httpUtils.instance
      const url = `/groupItems/${id}`
      HTTP.get(url)
        .then((res) => {
          this.form.subgroup = res.data.subgroupid
          this.form.groupID = res.data.groupid
          this.form.status = res.data.subgroupid?true:false
      
          this.form.device = this.devices.find(did=>did.id==res.data.deviceid);
          console.log({did: this.form.device,fdid:res.data.deviceid});
          this.getSubgroupss(res.data.groupid,);

          this.editModal = true
          this.loading = false
        })
        .catch((error) => {
          console.log('error', error)
            this.loading=false

        })
    },

     async getSubgroupss(id) {
      const HTTP = this.$httpUtils.instance;
      let formData = new FormData();
      formData.append("groupid", id);
      let res = await HTTP.post(
        "/customerSubGroups/getCustomerSubGroupByGroupId",
        formData
      )
        .then((res) => {
          if(res.data){
             this.subgroups = res.data
            .map((item) => {
              return {
                id: item.id,
                name: item.subgroupname,
              };
            })
            .sort((a, b) => {
              return a.name > b.name ? 1 : -1;
            });
          }
          console.log(this.subgroupsData)

         
        })
        .catch((e) => {
          //
        });
      // parse for "arnergy-select" us
    },


    updateGroup(e) {
      e.preventDefault()
      const HTTP = this.$httpUtils.instance
      let {form,updateID}=this
      const data = {
        groupid: form.groupID,
        subgroupid: form.subgroup,
        deviceid: form.device.id,
        id:updateID
      }
      this.loader = true
      console.log(data)
      HTTP.put('/groupItems', data)
        .then((res) => {
          if (res.data) {
            this.editModal = false
            this.showAlert()
            this.loader = false
            this.fetchGroupItems()
            this.form.subgroup = ''
            this.form.groupname = ''
            this.form.deviceid = ""
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    showAlert() {
      // Use sweetalert2
      this.$swal({
        title: 'Success',
        imageWidth: '40px',
        text: 'GroupItem Updated Successfully',
        icon: 'success',
        width: '550px',
      })
    },
     async fetchDevices() {
      const HTTP = this.$httpUtils.instance;
      const filter=JSON.stringify({where:{and:[{"CID":{"neq":  null}},{or:[{ "status": "commissioned"},{ "status": "completed"},{ "status": "scheduled"},{ "status": "requested"}]}]}})
      let res = await HTTP.get(`/installations?filter=${filter}`);

      // parse for "arnergy-select" use
      return res.data
        .map((item) => {
          return {
            id: item.CID || item.solarKitIds,
          };
        })
        .sort((a, b) => {
          return a.cid > b.cid ? 1 : -1;
        });
    },
  
  },
 async mounted() {
    this.devices =await this.fetchDevices()
    // this.fetchGroupItems()

 
    this.groups = this.getGroups
      .map((item) => {
        return {
          id: item.id,
          name: item.groupname,
        };
      })
      .sort((a, b) => {
        return a.name > b.name ? 1 : -1;
      });

  },
}
</script>

<style scoped>
.card-title {
  font-size: 2.6rem;
}

table th,
table th span {
  font-size: 0.7em;
}
.groupitem-table-height {
  height: calc(100vh - 450px);
}
</style>



// WEBPACK FOOTER //
// src/components/pages/user-mgt/GroupIteminfo.vue